import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Card, Typography, CardContent } from '@mui/material';
import Button from '@material-ui/core/Button';
import { captilizeString } from '../functionUtils';
import { updateProviderService, addProviderService } from '../../../services/yourCareTeamService';
import { InfoOutlined } from '@mui/icons-material';
import Label from '../type/Label';

const ViewCareNewProvider = (props) => {
    const dependentEnrollments = useSelector(
        state => state?.dependentEnrollments
    );

    const [providersList, setProvidersList] = useState([]);
    const [showProviders, setShowProviders] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [newSelectedProvider, setNewSelectedProvider] = React.useState('');
    const [filteredProviders, setFilteredProviders] = useState(providersList);
    const [selectedProvider, setSelectedProvider] = useState({});
    const [responseMsg, setResponseMsg] = useState('');
    const [isSpanish, setisSpanish] = useState(false);
    const coveredMembers = useSelector(state => state?.coverages?.coveredMembers?.coveredMemberDetails);

    const isRecentOrFuture = (date) => {
        if (!date) return false;
        const eff = new Date(date);
        if (Number.isNaN(eff.getTime())) return false;

        const cutoff = new Date();
        cutoff.setDate(cutoff.getDate() - 1);
        eff.setHours(0, 0, 0, 0);
        cutoff.setHours(0, 0, 0, 0);
        // disable if effective date is today or after
        return eff >= cutoff;
    };
    
    const randomSort = (data) => {
        const zipCode = dependentEnrollments && dependentEnrollments[0]?.zipCode;
        if (!zipCode) {
            setProvidersList(data);
            setFilteredProviders(data);
            return;
        }
        const matched = data.filter(item => item?.physicianPractices[0]?.address?.zipCode === dependentEnrollments[0].zipCode).sort(() => Math.random() -0.5);
        const nonMatched = data.filter(item => item?.physicianPractices[0]?.address?.zipCode !== dependentEnrollments[0].zipCode).sort(() => Math.random() -0.5);
        const finalData = [...matched, ...nonMatched];
        setProvidersList(finalData);
        setFilteredProviders(finalData);
    };

    const handleChooseNewPhysician = () => {
        setShowProviders(true);
        try {
            //const url1 = 'https://admin.mysmarthealth.org/provider/physician/physicianSearchSlim?type=primaryCareProvider&city=austin&state=TX&radius=50&network=DCHP-CHIP';
            const url = `https://admin.mysmarthealth.org/provider/physician/physicianSearchSlim?type=primaryCareProvider&city=${coveredMembers && coveredMembers[0]?.city}&state=${coveredMembers && coveredMembers[0]?.state}&radius=50&network=DCHP-CHIP`;
            
            fetch(url).then((res) => res.json())
                .then((data) => {
                    randomSort(data?.results);
                    
                });
        } catch (error) {
            console.log(error);
        }
    };

    const handleSelectProvider = (member) => {
        setOpen(true);
        const name = `${member?.firstName} ${member?.lastName}`;
        setNewSelectedProvider(name);
        setSelectedProvider(member);
    };

    const handleFilterSearch = (event) => {
        setisSpanish(false);
        if (event.target.value) {
            const filteredData = providersList.filter(name => (name.firstName.toLowerCase() || name.lastName.toLowerCase()).includes(event.target.value.toLowerCase()));
            setFilteredProviders(filteredData);
        } else {
            setFilteredProviders(providersList);
        }
    };

    const handleChangeProvider = () => {
        
        if (props.selectedMember.selectedMember?.providerName) {
            let fullName = selectedProvider.firstName +' '+ selectedProvider.lastName;
            const params = {
                providerNpi:selectedProvider.npi,
                providerName:fullName,
                providerFacilityName: selectedProvider.physicianPractices[0].practice.name,
                providerSpeciality: selectedProvider.physicianPractices[0].specialty.code
            };
            try {
                updateProviderService(props.memberAccountHeader, localStorage.getItem('tenantHandle'), params).then(res => (setResponseMsg(res),scrollTo(0,200))).catch(err => setResponseMsg(err?.res?.status));
            } catch (error) {
                console.log(error);
            }
        } else {
            let fullName = selectedProvider.firstName +' '+ selectedProvider.lastName;
            const params = {
                providerNpi:selectedProvider.npi,
                providerName:fullName,
                providerFacilityName: selectedProvider.physicianPractices[0].practice.name,
                providerSpeciality: selectedProvider.physicianPractices[0].specialty.code
            };
            try {
                addProviderService(props.memberAccountHeader,localStorage.getItem('tenantHandle'), params).then(res => setResponseMsg(res),scrollTo(0,200)).catch(err => setResponseMsg(err?.res?.status));
            } catch (error) {
                console.log(error);
            }
        }
        setOpen(false);

    };

    const formatPhoneNumber = (phoneNumberString) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          var intlCode = (match[1] ? '+1 ' : '');
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
      };

      const handleSpanishLangFilter = () => {
        setisSpanish(!isSpanish);
        if (!isSpanish) {
            const filteredData = providersList.filter(item => item.languages.indexOf('Spanish') > -1);
            setFilteredProviders(filteredData);
        } else {
            setFilteredProviders(providersList);
        }
      };

      const memberEffDate = props.selectedMember?.selectedMember?.providerEffectiveDate;
      const selfEffDate   = props.selectedMember?.selfMember?.providerEffectiveDate;

      // disable if either effective date is today or in the future
      const disableChoosePcp = isRecentOrFuture(memberEffDate) || isRecentOrFuture(selfEffDate);

    return (
        <>
        {responseMsg?.status == 200 && <Card className='successCardForSm'>
                <InfoOutlined color='primary' />
                <CardContent className='successCardContent'>
                    <Typography variant='h6'><Label id="requestAcknowledgement" /></Typography>
                    <Typography varaint='body1'><Label id="NewIDMailInfo"/></Typography>
                </CardContent></Card>}
            <div>
                <div className="CareTeamCardSection">
                    <Card className="care-team-card">
                        <div id="care-team-card">
                            <div className="care-team-details">
                                <Typography variant="h5" className="care-member-header">
                                    <Label id="NeedPCPQuestion" />
                                </Typography>
                            </div>
                            <div className='covered-member-tab view-pcp-container'>
                                <Button 
                                disabled={disableChoosePcp}
                                variant="outlined" color="secondary" onClick={handleChooseNewPhysician}><Label id="choosePCPLabel"/></Button>
                            </div>
                        </div>

                        {
                            showProviders ?
                                <div>
                                    <div id="care-team-card" >
                                        <div className="care-team-details" style={{ width: '100%' }}>
                                            <Typography variant="caption" className="care-member-header" color={'textSecondary'}>
                                                <Label id="SearchByName" />
                                            </Typography>
                                            <input id="care-team-input-full-width" placeholder="Search by entering provider name here" onChange={(event) => handleFilterSearch(event)} />
                                            <br /><br />
                                            <Typography variant="caption" className="care-member-header">
                                                <Label id="PCPListLabel"/>
                                            </Typography>
                                            <span style={{ float: 'right'}}>
                                                {
                                                    !(!Array.isArray(filteredProviders) || !filteredProviders.length) ? 
                                                    <>
                                                     <input type='checkbox' checked={isSpanish} onChange={handleSpanishLangFilter}/>
                                                <Typography variant="caption" className="care-member-header">
                                                    <Label id="speaksSpanish" />
                                                </Typography>
                                                </> : ''
                                                }
                                               
                                            </span>
                                        </div>
                                    </div>
                                    {!(!Array.isArray(filteredProviders) || !filteredProviders.length) && filteredProviders.length > 0 ? (
                                        filteredProviders.filter(item => item.acceptingNewPatients)?.map((member, index) => (
                                            <div key={index} id="care-team-card">
                                                <div className="care-team-details">
                                                    <Typography
                                                        variant="body1"
                                                        className="care-team-physician-name"
                                                    >{`Dr. ${captilizeString(member?.firstName)} ${captilizeString(member?.lastName)}`}</Typography>
                                                     <Typography variant="caption" className="care-member-relationship-phone">
                                                    <a href={`https://healthcare.ascension.org/find-care/provider/${member?.npi}`} rel="noreferrer" target="_blank" className="care-member-relationship-phone"><Label id="viewProfile"/></a>
                                                    </Typography>
                                                </div>
                                                <div className="care-team-details">
                                                    <Typography variant="body1" className="care-member-relationship">
                                                        {captilizeString(member?.physicianPractices[0]?.address?.deliveryLine1)} <br />
                                                        {captilizeString(member?.physicianPractices[0]?.address?.lastLine)}  <br />
                                                    </Typography>
                                                    <Typography variant="body1" >
                                                        <a className="care-member-relationship-phone" href={`tel:${member?.physicianPractices[0]?.phoneNumber?.value}`}>{formatPhoneNumber(member?.physicianPractices[0]?.phoneNumber?.value)}</a>
                                                    </Typography>
                                                </div>
                                                <div className='view-pcp-container'>
                                                    <Button variant="outlined" color="primary" onClick={() => handleSelectProvider(member)}><Label id="SELECTTHISPROVIDER"/></Button>
                                                </div>

                                            </div>
                                            // <a href="tel:555-555-5555">555-555-5555</a>
                                        ))
                                    ) : (
                                        <div id="care-team-card" >
                                            <div className="care-team-details" style={{ width: '100%' }}>

                                                <Typography variant="caption" className="care-member-header" color={'textSecondary'}>
                                                    <Label id="NoProvidersFound"/>
                                                </Typography> </div>
                                        </div>
                                    )}
                                </div>
                                : ''
                        }

                    </Card>
                </div>
            </div>

            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {
                        props.selectedMember.selectedMember?.providerName ? <Label id="confirmSwitch" /> : 'Choose your new physician'
                    }

                </DialogTitle>
                <DialogContent>
                    <Typography
                        variant="body1"
                        className="care-member-relationship"
                    >
                        {
                            props.selectedMember.selectedMember?.providerName ?
                                <span><Label id="AboutToSwitchPCP" /> <b>Dr. {props?.selectedMember?.selectedMember?.providerName}</b> <Label id="AboutToSwitchPCPNext"/> <b>Dr. {newSelectedProvider}</b><Label id="AboutToSwitchPCPLast"/></span>
                                :
                                <span>You are about to choose your new primary care physician to be <b>Dr. {newSelectedProvider}</b>. Sound good?</span>
                        }

                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(!open)} color="primary">
                        <Label id="NEVERMIND"/>
                    </Button>
                    <Button onClick={() => handleChangeProvider()} color="primary" autoFocus>
                        <Label id="YESCONFIRMED" />
                    </Button>
                </DialogActions>
            </Dialog>
            {/* <Dialog
                open={responseMsg?.message}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <Typography
                        variant="body1"
                        className="care-member-relationship"
                    >
                        {responseMsg?.message == 'PCP update failed' ? 'You are already updated to a new physician!' : responseMsg?.message}
                    </Typography>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setResponseMsg('')} color="primary">
                        CLOSE
                    </Button>

                </DialogActions>
            </Dialog> */}
        </>
    );
};

ViewCareNewProvider.propTypes = {
    selectedMember: PropTypes.object,
    memberAccountHeader: PropTypes.string
};
export default ViewCareNewProvider;
